export interface Testimonial {
  name: string;
  avatar: string;
  role: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    name: '李明',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20headshot%2C%20warm%20natural%20lighting%2C%20simple%20clean%20background%2C%20friendly%20expression%2C%20modern%20corporate%20style&width=120&height=120&seq=avatar-li-ming&orientation=squarish',
    role: '资深用户 · 使用成91 2年',
    content: '成91平台真的让我眼前一亮！界面设计简洁大气，功能也非常齐全。尤其是智能推荐系统，总能给我推送感兴趣的内容。用了两年多了，每次更新都能感受到团队在用心优化，强烈推荐！',
    rating: 5
  },
  {
    name: '王芳',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20headshot%2C%20warm%20natural%20lighting%2C%20simple%20clean%20background%2C%20confident%20smile%2C%20modern%20corporate%20style&width=120&height=120&seq=avatar-wang-fang&orientation=squarish',
    role: '内容创作者 · 使用成91 1年',
    content: '作为一个内容创作者，成91为我提供了很好的创作和展示平台。编辑器功能强大，数据分析工具帮助我更好地了解读者偏好。平台对创作者的扶持力度也很大，我的内容在这里获得了不错的曝光。',
    rating: 5
  },
  {
    name: '张伟',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20headshot%2C%20warm%20natural%20lighting%2C%20simple%20clean%20background%2C%20approachable%20look%2C%20modern%20business%20style&width=120&height=120&seq=avatar-zhang-wei&orientation=squarish',
    role: '企业用户 · 使用成91 6个月',
    content: '我们公司选择成91作为团队协作和信息共享的平台，效果超出预期。数据分析功能帮助我们更好地了解业务趋势，社区互动也让团队氛围更活跃。性价比很高，会继续使用下去。',
    rating: 4
  },
  {
    name: '陈雪',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20headshot%2C%20warm%20natural%20lighting%2C%20simple%20clean%20background%2C%20gentle%20smile%2C%20modern%20professional%20style&width=120&height=120&seq=avatar-chen-xue&orientation=squarish',
    role: '新用户 · 使用成91 2个月',
    content: '刚接触成91两个月，但已经被深深吸引了。上手非常简单，不需要太多学习成本。最喜欢的是社区氛围，大家都非常友好，有问题发出去很快就能得到解答。推荐给所有新朋友！',
    rating: 5
  },
  {
    name: '刘强',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20headshot%2C%20warm%20natural%20lighting%2C%20simple%20clean%20background%2C%20confident%20expression%2C%20modern%20corporate%20style&width=120&height=120&seq=avatar-liu-qiang&orientation=squarish',
    role: '高级会员 · 使用成91 1.5年',
    content: '升级高级会员后体验更上一层楼。专属的客服支持响应非常快，数据分析报表也更加详细。成91团队的更新节奏很快，每隔一段时间都有新惊喜。作为老用户，见证了平台的成长，真心觉得越来越好。',
    rating: 5
  },
  {
    name: '赵丽',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20headshot%2C%20warm%20natural%20lighting%2C%20simple%20clean%20background%2C%20friendly%20professional%20look%2C%20modern%20business%20style&width=120&height=120&seq=avatar-zhao-li&orientation=squarish',
    role: '自由职业者 · 使用成91 8个月',
    content: '成91帮我找到了很多志同道合的朋友，也拓展了我的业务渠道。平台的功能覆盖面很广，无论是信息获取还是社交需求都能满足。移动端体验也很好，随时随地都能使用，非常方便。',
    rating: 4
  }
];